import { ltv_controller_factory } from '../ltv_controller';

export default {
    url: '/by_day',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 900,
        title: 'by Day',
    },
    controller: [
        '$scope',
        'chartFilters',
        'life_time_api',
        ltv_controller_factory('by_day', 'life_time.LTVByDayChart'),
    ],
};
